<span [className]="wrapperClass()">
	<fa-icon
		[class]="iconClass()"
		[icon]="transformedIcon()"
		[size]="transformedSizeProp()"
		[fixedWidth]="true"
	></fa-icon>
</span>
